import React from 'react'
import { Switch } from 'react-router-dom'
import { RouteWithSubRoutes } from "../../config/Router";
import { connect, useDispatch, useSelector } from 'react-redux'
import ListRooms from '../../containers/ChatRooms/ListRooms/ListRooms';
import { useTokenCallback } from '../../utils/hooks/useTokenCallback';
import { getAllRooms } from '../../actions/userActions';
import { seeListChatCategories } from '../../admin/actions/categoriesActions';

const RootRoom = ({ routes }) => {
    const dispatch = useDispatch()
    const {allRooms} = useSelector(state=>state.userInfo)
    const {listChatCategories} = useSelector(state=>state.socialCategoriesAdmin)
    useTokenCallback(()=>{
        //dispatch(getAllRooms())
      //  dispatch(seeListChatCategories())
        
    },[])
    return (
        <div className="">
           
             <Switch>
                {routes.map((route, i) => (
                    <RouteWithSubRoutes key={i} {...route} />
                ))}
            </Switch> 
        </div>
    )
}


export default connect(null,)(RootRoom)